import React, { useState } from "react";
import { Grid, Typography, Link, makeStyles, Box } from "@material-ui/core";
import clsx from "clsx";
import Overlay from "./Overlay";
import styled from "styled-components";
import { labelsColors } from "../../core/redux/dataMap/label";
import useLanguage from "../../hooks/useLanguage";

const useStyles = makeStyles((theme) => ({
  snippet: {
    borderBottom: "1px solid rgba(234, 234, 234, 0.5)",
    width: "inherit",
    padding: "10px 5px",
    backgroundColor: theme.palette.background.main,
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
      borderRadius: "5px",
      /* border: 1px solid rgba(234, 234, 234, 0.5), */
      cursor: "grab",
    },
    "&:active": {
      border: "none",
    },
  },
  snippetDragging: {
    borderBottom: `1px solid ${theme.palette.border.main}`,
    width: "inherit",
    padding: "10px 5px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "5px",
    " & a ": {
      color: `${theme.palette.primary.contrastText} !important`,
    },
    " & p ": {
      color: `${theme.palette.primary.contrastText} !important`,
    },
  },
  snippetSave: {
    borderBottom: "1px solid rgba(234, 234, 234, 0.5)",
    width: "inherit",
    padding: "10px 5px",
    backgroundColor: theme.palette.background.hover,
    borderRadius: "5px",
    fontStyle: "italic",
  },
}));

export const ArticlePaperSnippet = ({
  article,
  isEditor,
  snippet,
  handleDelete,
  isDragging,
  setLabel,
  removeLabel,
}) => {
  const [isEditing, setEditing] = useState(false);
  const classes = useStyles();
  const { language } = useLanguage();
  const { translate } = language;
  const isSaved =
    isEditor &&
    article.editor &&
    article.editor.snippets &&
    article.editor.snippets.some(
      (articleSnippet) => articleSnippet.id === snippet.id
    );
  return (
    <Overlay
      snippet={snippet}
      isFocus={isEditing}
      onClose={() => setEditing(false)}
      setLabel={(label) => setLabel(snippet.id, label)}
      removeLabel={(label) => removeLabel(snippet.id, label)}
      onDelete={handleDelete}
      articleId={article.id}
    >
      <Grid
        container
        className={clsx({
          [classes.snippetSave]: isSaved,
          [classes.snippetDragging]: isDragging,
          [classes.snippet]: !isDragging,
        })}
      >
        <Grid item>
          <Typography>{snippet.text}</Typography>
        </Grid>
        <Grid item md={12}>
          <Grid container alignItems="center">
            <Grid
              item
              className="snippet-paper-source-tag"
              md={snippet.labels && snippet.labels.length ? 7 : 11}
            >
              <Link
                href={snippet.source.url || snippet.reportUrl}
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
              >
                {snippet.source.name || translate.source}
              </Link>
            </Grid>
            {snippet.labels && !!snippet.labels.length && (
              <Grid item md={4}>
                <Box display="flex" justifyContent="flex-end">
                  {snippet.labels.map((label) => (
                    <LabeColor color={label.color} key={label.id} />
                  ))}
                </Box>
              </Grid>
            )}
            <Grid item className="snippet-paper-buttons" md={1}>
              <ul>
                {/* <li>
                  <i className="fa fa-comment-o" aria-hidden="true"></i>
                </li> */}
                <li onClick={() => setEditing(true)}>
                  <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                </li>
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Overlay>
  );
};

export const LabeColor = styled.div`
  width: 35px;
  height: 12px;
  border-radius: 10px;
  background: ${(props) => labelsColors[props.color]};
  margin: 0 3px;
`;
